import { Palette } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

export const IMG_STYLES = [
  { v: "minimal", l: "Simple", d: "Ringkas & bersih" },
  { v: "modern", l: "Modern", d: "Moden & bergaya" },
  { v: "poster", l: "Poster", d: "Tegas & menonjol" },
  { v: "korporat", l: "Korporat", d: "Profesional" },
  { v: "gradien", l: "Gradien", d: "Warna bercampur" },
  { v: "3d", l: "3D", d: "Bentuk 3D comel" },
  { v: "kartun", l: "Kartun", d: "Comel & ceria" },
  { v: "catair", l: "Cat Air", d: "Lembut & seni" },
  { v: "elegan", l: "Elegan", d: "Mewah premium" },
  { v: "neon", l: "Neon", d: "Bercahaya gelap" },
  { v: "tipografi", l: "Tipografi", d: "Teks sahaja" },
  { v: "retro", l: "Retro", d: "Vintaj 70-an" },
];
export const IMG_PALETTES = [
  { v: "auto", l: "Auto (ikut topik)", c: [] },
  { v: "biru", l: "Biru korporat", c: ["#1E3A8A", "#38BDF8", "#FFFFFF"] },
  { v: "hijau", l: "Hijau segar", c: ["#15803D", "#86EFAC", "#FEF9C3"] },
  { v: "merah", l: "Merah jualan", c: ["#DC2626", "#FACC15", "#FFFFFF"] },
  { v: "pastel", l: "Pastel lembut", c: ["#F9A8D4", "#A7F3D0", "#C4B5FD"] },
  { v: "hitamemas", l: "Hitam & emas", c: ["#0A0A0A", "#D4AF37"] },
  { v: "custom", l: "Warna jenama saya", c: [] },
];
const KEY = "pp_img_style";
export const DEFAULT_IMG_STYLE = { style: "minimal", palette: "auto", colors: ["#2563EB", "#F59E0B"] };
export const loadImgStyle = () => { try { return { ...DEFAULT_IMG_STYLE, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return DEFAULT_IMG_STYLE; } };
export const saveImgStyle = (s) => localStorage.setItem(KEY, JSON.stringify(s));
// Brand style saved on the server (same on every device).
export const fetchBrandStyle = () => api.get("/ai/brand-style").then((r) => r.data);
export const saveBrandStyle = (s) => api.put("/ai/brand-style", { style: s.style, palette: s.palette, colors: s.colors }).then((r) => r.data);
// Body fields sent to /ai/image and /posts image_vary.
export const styleBody = (s) => ({ style: s.style, palette: s.palette, colors: s.palette === "custom" ? s.colors : [] });

const Swatches = ({ colors }) => <span className="flex gap-0.5">{colors.map((c) => <span key={c} className="h-3 w-3 rounded-sm border border-white/20" style={{ background: c }} />)}</span>;

export default function ImageStyleOptions({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="space-y-2" data-testid="composer-image-style-options">
      <p className="text-xs font-medium text-muted-foreground">Gaya design</p>
      <div className="grid grid-cols-4 gap-1.5 sm:grid-cols-6" role="radiogroup" aria-label="Gaya design">
        {IMG_STYLES.map((s) => (
          <button key={s.v} type="button" role="radio" aria-checked={value.style === s.v} onClick={() => set({ style: s.v })} title={s.d}
            className={`group overflow-hidden rounded-lg border text-left transition-colors duration-150 ${value.style === s.v ? "border-violet-500 bg-violet-500/15 text-white ring-1 ring-violet-500" : "border-border bg-background/60 text-muted-foreground hover:border-violet-500/50 hover:text-white"}`}
            data-testid={`composer-image-style-${s.v}`}>
            <img src={`/img-styles/${s.v}.webp`} alt={`Contoh gaya ${s.l}`} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-200 group-hover:scale-105" data-testid={`composer-image-style-preview-${s.v}`} />
            <span className="block truncate px-1.5 py-1 text-[11px] font-semibold">{s.l}</span>
          </button>
        ))}
      </div>
    <div className="flex flex-wrap items-center gap-2">
      <Palette className="h-4 w-4 text-violet-300" />
      <Select value={value.palette} onValueChange={(palette) => set({ palette })}>
        <SelectTrigger className="h-8 w-[190px] bg-background text-xs" data-testid="composer-image-palette-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {IMG_PALETTES.map((p) => <SelectItem key={p.v} value={p.v}><span className="flex items-center gap-2">{p.c.length > 0 && <Swatches colors={p.c} />}{p.l}</span></SelectItem>)}
        </SelectContent>
      </Select>
      {value.palette === "custom" && value.colors.map((c, i) => (
        <input key={i} type="color" value={c} onChange={(e) => set({ colors: value.colors.map((x, j) => (j === i ? e.target.value.toUpperCase() : x)) })}
          className="h-8 w-9 cursor-pointer rounded border border-border bg-background p-0.5" aria-label={`Warna jenama ${i + 1}`} data-testid={`composer-image-color-${i}`} />
      ))}
    </div>
    </div>
  );
}
